var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import { Toast as ToastBS } from 'react-bootstrap';
//TODO: Check how to render properties in info
var Toast = React.memo(function (_ref) {
    var children = _ref.children,
        show = _ref.show,
        toggleShow = _ref.toggleShow,
        variant = _ref.variant,
        delay = _ref.delay;

    return React.createElement(
        ToastBS,
        { delay: delay, autohide: true, show: show, onClose: toggleShow, className: 'bg-' + variant + ' text-white' },
        React.createElement(
            ToastBS.Body,
            null,
            children
        )
    );
});
Toast.defaultProps = {
    variant: "primary",
    delay: 5000
};
Toast.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, ToastBS.propTypes, {
    variant: PropTypes.oneOf(['primary', 'success', 'danger', 'warning', 'info'])
}) : {};

export default Toast;